import React from "react";
import styles from "./index.module.css";
import menuIcon from "../../../../assets/icons/ellipsisMenu.png";
import { message } from "antd";
import { useDispatch } from "react-redux";
import addSection from "../../../../assets/icons/mobileIcons/duplicate.png";
import deleteSectionIcon from "../../../../assets/icons/mobileIcons/deleteOutlinedBlack.png";
import { duplicateNonStoreSection } from "../../../Builder/builderServices/utils";
import { openSectionDeleteModal, setSelectedLinkInBio, setSelectedScreen } from "../../../../redux/slice/dashboardSlice";
import { getBrandLogo } from "../../utils";

const index = ({ item, isAnyMenuOpened, isMenuOpened, setIsMenuOpened, brandsIcons, closeMenu }) => {
    const dispatch = useDispatch();

    const onDuplicate = (e) => {
        e.stopPropagation();
        duplicateNonStoreSection(item);
        message.success("Duplicate Section Created");
        closeMenu();
    };
    const onDelete = async (e) => {
        e.stopPropagation();
        closeMenu();
        dispatch(openSectionDeleteModal());
        dispatch(setSelectedLinkInBio(item));
        message.success("Section Deleted");
    };
    const handleClick = () => {
        if (isAnyMenuOpened) {
            closeMenu();
        } else {
            dispatch(setSelectedLinkInBio(item));
            dispatch(setSelectedScreen("linkinbio"));
        }
    };
    const filteredLinks = item.links.filter((link) => link.isDeleted === false);
    return (
        <div className={styles.linksContainer} onClick={handleClick}>
            <div className={styles.titleContainer}>
                <span className={styles.title}>{item.title}</span>
                <img
                    className={styles.menu}
                    src={menuIcon}
                    alt="ellipses-icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsMenuOpened(!isMenuOpened);
                    }}
                />
            </div>
            {filteredLinks.slice(0, 2).map((link) => {
                if (link.isDeleted) return <></>;
                const iconSrc = getBrandLogo(brandsIcons, link?.url);

                return (
                    <div className={styles.link}>
                        <img className={styles.logo} src={iconSrc} alt={"social-logo"} />
                        <span className={styles.text}>{link.url}</span>
                    </div>
                );
            })}
            {filteredLinks.length > 2 && <span className={styles.extraLinksCount}>{`+${item.links.length - 2} links`}</span>}
            {isMenuOpened && (
                <ul className={styles.sectionMenu}>
                    <li className={styles.sectionMenuItem} onClick={onDuplicate}>
                        <img src={addSection} />
                        <span>Duplicate</span>
                    </li>
                    <li className={styles.sectionMenuItem} onClick={onDelete}>
                        <img src={deleteSectionIcon} />
                        <span>Delete</span>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default index;
